import { useInfiniteQuery, useQuery } from '@tanstack/react-query'
import type {
  UserGetLoyaltyTransactionHistoryParams,
  UserListReferralsParams,
} from '../api'
import {
  getReferralCodesOptions,
  getReferralListOptions,
  getLoyaltyTransactionHistoryOptions,
  getLoyaltyPortfolioOptions,
  getLoyaltyMissionsOptions,
} from './user-referral.options'

export const useGetReferralCodes = () => {
  return useQuery(getReferralCodesOptions())
}

export const useGetReferralList = (params: UserListReferralsParams) => {
  return useInfiniteQuery(getReferralListOptions(params))
}

export const useGetLoyaltyTransactionHistory = (
  params: UserGetLoyaltyTransactionHistoryParams,
) => {
  return useInfiniteQuery(getLoyaltyTransactionHistoryOptions(params))
}

export const useGetLoyaltyMissions = () => {
  return useQuery(getLoyaltyMissionsOptions())
}

export const useGetLoyaltyPortfolio = () => {
  return useQuery(getLoyaltyPortfolioOptions())
}
